/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../../../core/error/error-name';

/**
 * Triviální mapovač cest souborového systému pro webovou platformu.
 * @implements {FileSystemMapper}
 * @memberof AdapterWeb
 */
class FileSystemMapper {
  /** @inheritdoc */
  hasFile() {
    return false;
  }

  /** @inheritdoc */
  hasLocalhost() {
    return false;
  }

  /** @inheritdoc */
  toFileUrl(path) {
    return new Promise(() => {
      const error = new Error('File URLs are not supported.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  toLocalhostUrl(path) {
    return new Promise(() => {
      const error = new Error('Localhost URLs are not supported.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }
}

export default FileSystemMapper;
